import { Star, Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { motion } from "framer-motion";
import { useState, useRef } from "react";

const testimonials = [
  {
    name: "Anna K.",
    text: "Świetny występ! Nasi pracownicy byli zachwyceni, a pozytywna energia utrzymywała się jeszcze przez wiele dni.",
  },
  {
    name: "Marek N.",
    text: "Profesjonalne podejście i świetne dostosowanie żartów do naszej branży. Polecam!",
  },
  {
    name: "Katarzyna W.",
    text: "Najlepsza impreza firmowa, jaką mieliśmy! Komik idealnie wyczuł atmosferę i bawił wszystkich od początku do końca.",
  },
  {
    name: "Tomasz B.",
    text: "Perfekcyjne przygotowanie, punktualność i niesamowity kontakt z publicznością. Na pewno wrócimy!",
  },
  {
    name: "Ewa S.",
    text: "Rewelacyjny występ na naszej gali. Goście do dziś wspominają ten wieczór. Gorąco polecam!",
  },
  {
    name: "Piotr M.",
    text: "Występ przeszedł nasze najśmielsze oczekiwania. Profesjonalizm na najwyższym poziomie.",
  },
];

export const Testimonials = () => {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: "left" | "right") => {
    if (scrollRef.current) {
      const scrollAmount = 340;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="py-24 bg-secondary/50 relative">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <span className="text-accent font-semibold text-sm tracking-widest uppercase">Opinie</span>
          <h2 className="text-4xl md:text-5xl font-montserrat font-bold mt-3 text-primary">
            Co mówią nasi Klienci?
          </h2>
        </motion.div>

        <div className="relative">
          <button
            onClick={() => scroll("left")}
            className="absolute -left-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-accent hover:text-white transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <button
            onClick={() => scroll("right")}
            className="absolute -right-4 top-1/2 -translate-y-1/2 z-10 w-10 h-10 rounded-full bg-white shadow-lg flex items-center justify-center hover:bg-accent hover:text-white transition-colors"
          >
            <ChevronRight className="w-5 h-5" />
          </button>

          <div
            ref={scrollRef}
            className="flex gap-6 overflow-x-auto scrollbar-hide pb-4 px-2 snap-x snap-mandatory"
            style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
          >
            {testimonials.map((testimonial, i) => (
              <motion.div
                key={testimonial.name}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 * i }}
                className="min-w-[300px] w-[300px] flex-shrink-0 p-8 rounded-2xl bg-white shadow-sm hover:shadow-lg transition-shadow relative flex flex-col snap-start"
              >
                <Quote className="w-10 h-10 text-accent/15 absolute top-6 right-6" />
                <div className="flex gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star key={s} className="w-4 h-4 text-gold fill-gold" />
                  ))}
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed italic flex-1">"{testimonial.text}"</p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center">
                    <span className="text-accent font-bold text-sm">{testimonial.name.charAt(0)}</span>
                  </div>
                  <div>
                    <p className="font-montserrat font-bold text-primary text-sm">{testimonial.name}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
